// Maison Solenuit (26/10/2026) : pastilles des coloris sous les cartes produits (snippets/ms-carte-coloris).
// Survol ou focus d'une pastille : la carte montre le dos de ce coloris, et son devant au survol de la carte.
// 30/10/2026 (Adrien, sur iPhone : photo cassée « ? » en revenant en arrière après avoir choisi un t-shirt) : sur un
// écran tactile, toucher une pastille ouvre la fiche ; Safari déclenchait aussi le survol, la carte commençait à
// charger la photo d'un autre coloris, le départ vers la fiche coupait ce chargement et, au retour (page gardée en
// mémoire par le navigateur), la photo restait cassée. Désormais : le survol ne change la photo qu'avec une souris ou
// au clavier, et au retour en arrière chaque carte retrouve sa photo d'origine.
(() => {
  const poser = (img, src, srcset) => {
    if (!img || !src) return;
    if (img.dataset.msOrigSrc === undefined) {
      img.dataset.msOrigSrc = img.getAttribute('src') || '';
      img.dataset.msOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.srcset = srcset || '';
    img.src = src;
  };

  const montrer = (pastille) => {
    const carte = pastille.closest('.card-wrapper');
    if (!carte || pastille.classList.contains('is-active')) return;
    const groupe = pastille.parentElement;
    if (groupe.dataset.msActiveOrig === undefined) {
      const active = groupe.querySelector('.ms-coloris__pastille.is-active');
      groupe.dataset.msActiveOrig = active ? String([...groupe.children].indexOf(active)) : '';
    }
    const images = carte.querySelectorAll('.card__media .media img');
    poser(images[0], pastille.dataset.msDos, pastille.dataset.msDosSrcset);
    poser(images[1], pastille.dataset.msDevant, pastille.dataset.msDevantSrcset);
    groupe
      .querySelectorAll('.ms-coloris__pastille')
      .forEach((p) => p.classList.toggle('is-active', p === pastille));
  };

  const pastilleDe = (event) => event.target.closest && event.target.closest('.ms-coloris__pastille');

  // souris seulement (un doigt déclenche aussi pointerover, avec pointerType « touch »)
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const pastille = pastilleDe(event);
    if (pastille) montrer(pastille);
  });
  // clavier seulement (focus visible), pas le focus donné par un toucher
  document.addEventListener('focusin', (event) => {
    const pastille = pastilleDe(event);
    if (pastille && pastille.matches(':focus-visible')) montrer(pastille);
  });

  // retour en arrière : chaque carte reprend sa photo et sa pastille d'origine
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('.card__media .media img').forEach((img) => {
      if (img.dataset.msOrigSrc === undefined) return;
      img.srcset = img.dataset.msOrigSrcset;
      img.src = img.dataset.msOrigSrc;
      delete img.dataset.msOrigSrc;
      delete img.dataset.msOrigSrcset;
    });
    document.querySelectorAll('[data-ms-coloris]').forEach((groupe) => {
      if (groupe.dataset.msActiveOrig === undefined) return;
      const rang = groupe.dataset.msActiveOrig;
      groupe
        .querySelectorAll('.ms-coloris__pastille')
        .forEach((p) => p.classList.toggle('is-active', rang !== '' && [...groupe.children].indexOf(p) === Number(rang)));
      delete groupe.dataset.msActiveOrig;
    });
  });
})();
